
export type GetUserProfile200PreferencesTheme = typeof GetUserProfile200PreferencesTheme[keyof typeof GetUserProfile200PreferencesTheme];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserProfile200PreferencesTheme = {
  light: 'light',
  dark: 'dark',
  auto: 'auto',
} as const;
